import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentHealth } from '../../lib/types/models/enrollment/enrollment-health'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentHealth<T extends FieldsSelector<EnrollmentHealth>>(
  id: number,
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.enrollments.getEnrollmentHealth.url, { id }), {
        fields
      })
    )
    .get<SelectFields<EnrollmentHealth, T>>()
}
